export default __webpack_public_path__ + "static/media/Lab.50c6780d.svg";